enum MercureMessageType {
  Create = "create",
  Update = "update",
  Delete = "delete"
}

export default MercureMessageType
